const UserRoles = {
    ATS_ADMIN: 'ATS_ADMIN',
    BASIC: 'BASIC',
    DELEGATE: 'DELEGATE',
};

const AdminUserRoles = {
    ROLE_ADMIN_ROOT: 'ROLE_ADMIN_ROOT',
    ROLE_ADMIN_PRODUCT: 'ROLE_ADMIN_PRODUCT',
    ROLE_ADMIN_CS: 'ROLE_ADMIN_CS',
    ROLE_ADMIN_FINANCE: 'ROLE_ADMIN_FINANCE',
};

export { UserRoles, AdminUserRoles}